/* TENDON — timeline s lanem. Lano (SVG path) se generuje z reálných pozic hexagonů
   roků, dokresluje se podle scrollu, milníky se odhalují přes IntersectionObserver.
   Reduced motion: vše viditelné, lano plně dokreslené, žádné animace. */
if (!customElements.get('tdn-timeline')) {
  class TdnTimeline extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.wrap = this.querySelector('.tdn-tl__wrap');
      this.svg = this.querySelector('.tdn-tl__rope');
      this.paths = this.svg ? Array.from(this.svg.querySelectorAll('path')) : [];
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inView = false;

      this.draw = this.draw.bind(this);
      this.onScroll = this.onScroll.bind(this);

      // sticky nav pod skutečnou hranou headeru
      var nav = this.querySelector('.tdn-tl__nav');
      var hdr = document.querySelector('.cc-header') || document.querySelector('header');
      if (nav && hdr) {
        var pend = false;
        var setTop = function () {
          nav.style.top = Math.max(Math.round(hdr.getBoundingClientRect().bottom), 0) + 'px';
          pend = false;
        };
        window.addEventListener('scroll', function () {
          if (!pend) { pend = true; requestAnimationFrame(setTop); }
        }, { passive: true });
        setTop();
      }

      // kreslení lana + redraw při resize a po načtení fontů
      if (this.wrap && this.svg) {
        new ResizeObserver(this.draw).observe(this.wrap);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.draw);
        this.draw();
      }

      // reveal milníků
      if (!this.reduced && 'IntersectionObserver' in window) {
        var reveal = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-on'); reveal.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -18% 0px' });
        this.querySelectorAll('.tdn-tl__item, .tdn-tl__quote').forEach(function (el) { reveal.observe(el); });
      } else {
        this.querySelectorAll('.tdn-tl__item, .tdn-tl__quote').forEach(function (el) { el.classList.add('is-on'); });
      }

      // potlačení fixní lanové linky + viditelnost sekce
      var self = this;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.inView = e.isIntersecting;
            document.body.classList.toggle('tdn-rail-off', e.isIntersecting);
          });
        }, { rootMargin: '10% 0px 10% 0px' }).observe(this);
      }

      // aktivní éra v navigaci
      var chips = this.querySelectorAll('.tdn-tl__nav-chip');
      if (chips.length && 'IntersectionObserver' in window) {
        var eras = this.querySelectorAll('.tdn-tl__era');
        var eraIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            chips.forEach(function (c) {
              c.setAttribute('aria-current', c.getAttribute('href') === '#' + e.target.id ? 'true' : 'false');
            });
          });
        }, { rootMargin: '-30% 0px -55% 0px' });
        eras.forEach(function (el) { eraIO.observe(el); });
      }

      // dokreslování podle scrollu
      if (!this.reduced) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      // video facade
      this.addEventListener('click', function (evt) {
        var btn = evt.target.closest('.tdn-tl__play');
        if (!btn) return;
        var media = btn.closest('.tdn-tl__media');
        var id = media.getAttribute('data-video-id');
        if (!id) return;
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        ifr.allow = 'autoplay; encrypted-media; picture-in-picture';
        ifr.allowFullscreen = true;
        ifr.title = 'Video';
        media.innerHTML = '';
        media.appendChild(ifr);
      });
    }

    draw() {
      var wrapRect = this.wrap.getBoundingClientRect();
      if (!wrapRect.height) return;
      var years = Array.from(this.querySelectorAll('.tdn-tl__year'));
      var pts = years.map(function (y) {
        var r = y.getBoundingClientRect();
        return { x: r.left + r.width / 2 - wrapRect.left, y: r.top + r.height / 2 - wrapRect.top };
      });
      if (!pts.length) return;

      this.svg.setAttribute('viewBox', '0 0 ' + Math.round(wrapRect.width) + ' ' + Math.round(wrapRect.height));
      this.svg.setAttribute('preserveAspectRatio', 'none');

      var d = 'M ' + pts[0].x.toFixed(1) + ' 0 L ' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var i = 1; i < pts.length; i += 1) {
        var a = pts[i - 1];
        var b = pts[i];
        var midY = (a.y + b.y) / 2;
        d += ' C ' + a.x.toFixed(1) + ' ' + midY.toFixed(1) + ', ' + b.x.toFixed(1) + ' ' + midY.toFixed(1) + ', ' + b.x.toFixed(1) + ' ' + b.y.toFixed(1);
      }
      var last = pts[pts.length - 1];
      d += ' L ' + last.x.toFixed(1) + ' ' + Math.round(wrapRect.height);

      this.paths.forEach(function (p) { p.setAttribute('d', d); });

      var main = this.paths[0];
      if (main) {
        this.len = main.getTotalLength();
        if (this.reduced) {
          main.style.strokeDasharray = 'none';
          main.style.strokeDashoffset = '0';
        } else {
          main.style.strokeDasharray = this.len;
          this.onScroll();
        }
      }
    }

    onScroll() {
      if (this.ticking || !this.len) return;
      this.ticking = true;
      var self = this;
      requestAnimationFrame(function () {
        self.ticking = false;
        if (!self.inView) return;
        var r = self.wrap.getBoundingClientRect();
        var seen = (window.innerHeight * 0.75 - r.top) / r.height;
        seen = Math.min(Math.max(seen, 0), 1);
        var main = self.paths[0];
        main.style.strokeDashoffset = Math.round(self.len * (1 - seen));
      });
    }
  }

  customElements.define('tdn-timeline', TdnTimeline);
}
